<template>
    <div :class="{ 'card' : !isOnlyContent }">
        <div
            v-if="!isOnlyContent"
            class="card-header">
            <div class="font-weight-bold">医師情報</div>
        </div>
        <div :class="{ 'card-body' : !isOnlyContent }">
            <div
                v-if="doctor !== null"
                class="p-2">
                <doctor-info
                    :doctor="doctor"
                    doctor-introduction-type="all">
                </doctor-info>
            </div>
        </div>
    </div>
</template>

<script>
    import YokumiruHelper from '../../YokumiruHelper'
    import constants from '../../constants'

    export default {
        props: {
            doctorId: {
                type: Number,
                default: null,
            },
            dataConsultation: {
                type: Object,
                default: null,
            },
            isOnlyContent: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                helper: YokumiruHelper,
                doctor: null,
                consultation: null,
            }
        },

        created() {
            if (this.doctorId) {
                this.fetchDoctorProfile()
            }

            if (this.dataConsultation) {
                this.consultation = this.dataConsultation
                this.doctor = this.consultation.doctor
            }
        },

        methods: {
            fetchDoctorProfile: function () {
                const endpoint = `${constants.user.doctors.endpoint.base}/${this.doctorId}`

                axios.get(endpoint).then(({data}) => this.doctor = data.data)
            },
        }
    }
</script>
